import { IQuizLoaderService } from '@lingvo-news/contracts';
import { Language } from '@lingvo-news/contracts';
import { QuizStep, QuizMode } from '@lingvo-news/contracts';
import type { QuizWord } from '@lingvo-news/contracts';
import { IQuizLoader } from '@lingvo-news/contracts';
import { QuizLoader } from '@lingvo-news/contracts';
import { IQuizzService } from '@lingvo-news/contracts';
import { serviceContainer } from '../store/service-container';

/**
 * Implementation of IQuizLoaderService using Vue stores
 */
export class QuizLoaderServiceImpl implements IQuizLoaderService {

	getQuizLoader(
		userId: string | undefined,
		nativeLanguage: Language,
		learnedLanguage: Language,
		quizType: QuizMode,
		contextId?: string,
		wordCount?: number
	): IQuizLoader {
		const service = serviceContainer.get(IQuizzService);
		return new QuizLoader(
			service,
			userId,
			nativeLanguage,
			learnedLanguage,
			quizType,
			contextId,
			wordCount
		);
	}

	convertQuizStepsToQuizWords(steps: QuizStep[]): QuizWord[] {
		return steps.map(step => ({
			validVariant: {
				id: step.correctWord.id,
				original: step.correctWord.sourceWord,
				translation: step.correctWord.translation,
				transliteration: step.correctWord.transliteration
			},
			invalidVariants: step.invalidOptions?.map(option => ({
				original: option.sourceWord,
				translation: option.translation,
				transliteration: option.transliteration
			})) || []
		}));
	}
}
